import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { withNamespaces } from 'react-i18next';
import loader from '../../Comman/images/loader.gif'
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import imageCompression from 'browser-image-compression';
import { Editor } from 'primereact/editor';
import { baseUrl } from '../../Comman/apiEndPoints';

const options = {
    maxSizeMB: 2.0,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 600,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
}

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

var svValidator;
var engValidator;
var currentLang;

class LogoSettingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Description: '',
            Image: '',
            ApplicationLogo: ''
        }
        this.handleInput = this.handleInput.bind(this);

        if (sessionStorage.getItem('Language')) {
            currentLang = sessionStorage.getItem('Language');
        }
        else {
            currentLang = "en";
        }
    }
    componentWillReceiveProps(nextProps) {
        // console.log("next", nextProps);
        if (nextProps.getLogoSettingData.Message != this.props.getLogoSettingData.Message) {
            if (nextProps.getLogoSettingData.statusCode == 200) {
                swal(nextProps.getLogoSettingData.Message, {
                    icon: "success",
                });
                this.props.getApplicationLogoData();
            }
        }
        this.translateLang();
    }
    translateLang() {
        var language;
        if (sessionStorage.getItem('Language')) {
            language = sessionStorage.getItem('Language');
        }
        else {
            language = "en";
        }
        if (language == "en") {
            this.validator = engValidator;
        }
        else {
            this.validator = svValidator;
        }
    }
    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required: 'The :attribute field is required.',
            min: 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required: 'Fältet :attribute krävs.',
            min: ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale: 'en'
            }
        );
        svValidator = new SimpleReactValidator(
            {
                locale: 'sv'
            }
        );
        this.validator = engValidator;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.getLogoSettingData != this.props.getLogoSettingData) {
            if (this.props.getLogoSettingData.emailLogoDetail) {
                let data = this.props.getLogoSettingData.emailLogoDetail ? this.props.getLogoSettingData.emailLogoDetail : null;
                this.setState({
                    Description: data.Description,
                    Image: '',
                    ApplicationLogo: baseUrl + data.ApplicationLogo
                })
            }
        }
        sleep(500).then(() => {
            console.log("setstate", this.state);
        })
    }
    handleInput(e) {
        this.setState({
            Description: e.htmlValue
        })
    }
    save() {
        const formData = new FormData();
        formData.append('Description', this.state.Description)
        formData.append('ImageName', this.state.Image ? this.state.Image.name : '')
        formData.append('ApplicationLogo', this.state.Image)
        this.props.addLogo(formData);
    }
    deleteImage() {
        this.setState({ ApplicationLogo: '' })
    }
    imageUpload = (event) => {
        let file = event.target.files[0];
        var self = this;
        let reader = new FileReader();
        imageCompression(file, options)
            .then(function (compressedFile) {
                self.setState({ Image: compressedFile })
                reader.readAsDataURL(compressedFile);
                reader.onloadend = function () {
                    // self.setState(prevState => ({ newCarouselData : 
                    //     {...prevState.newCarouselData,
                    //         PageLogo: reader.result,
                    //     },
                    //     }))
                    self.setState({ ApplicationLogo: reader.result })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        // let reader = new FileReader();
        // reader.onload = () => {
        //     this.setState({ image : file})
        //     this.setState( prevState => ({ newCarouselData : 
        //         {...prevState.newCarouselData, PageLogo : reader.result}
        //     }))
        //   };
        //   reader.readAsDataURL(file);
    }
    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Email Setting.Logo Setting')}</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className=" forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <form>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="EmailSubject" className="form-label">{t('Email Setting.upload_logo_image')}</label>
                                            </div>

                                            <div className="col-sm-9 image-width-100">
                                                {
                                                    this.state.ApplicationLogo ?
                                                        <div>
                                                            <img src={this.state.ApplicationLogo} width="300px" height="auto" />
                                                            <button type="button" className="btn btn-primary del-img" onClick={() => { this.deleteImage() }}>{t('Carousel Setting.Delete Image')}</button>
                                                        </div>
                                                        :
                                                        <div>
                                                            <input type='file' accept="image/*" name={'ApplicationLogo'} onChange={this.imageUpload}
                                                                id="editImageUpload" className="hide_input_type_file" />
                                                            <label for="editImageUpload" className="choose-file-btn">{t('Notification Setting.Select Image')}</label>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="EmailSubject" className="form-label">{t('Email Setting.description')}</label>
                                            </div>
                                            <div className="col-md-9">
                                                {/* <textarea
                                                    name="description"
                                                    onChange={this.handleInput}
                                                    value={this.state.Description}
                                                    placeholder={t('Email Setting.description')}
                                                    rows="6" cols="70"
                                                    className="insert-laram-textarea"
                                                >
                                                </textarea> */}
                                                <Editor style={{height:'200px'}} 
                                                    value={this.state.Description} 
                                                    onTextChange={(e) => this.handleInput(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p className='butn-center'>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary general-btn"
                                                    onClick={() => { this.save() }}
                                                    disabled={this.props.getLogoSettingData.isLoading == true}
                                                >
                                                    {t('First_Responder.Save')}
                                                </button>

                                                {
                                                    this.props.getLogoSettingData.isLoading ?
                                                        <img src={loader} width="30" alt="" /> : ''
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        )
    }
}

export default withNamespaces()(withRouter(LogoSettingComponent));

